var React = require('react');

function Tumblr (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M35.7 41.5C34.4 43 31.2 44 28.4 44h-.3c-9.4 0-11.5-6.9-11.5-11V21.8h-3.7c-.4 0-.8-.3-.8-.8v-5.3c0-.6.4-1.1.9-1.2 4.8-1.7 6.4-5.9 6.6-9.1 0-1 .5-1.4 1.2-1.4h5.5c.4 0 .8.3.8.8v9h6.5c.4 0 .8.3.8.8V21c0 .4-.3.8-.8.8h-6.5v10.4c0 2.6 1.7 3.3 2.8 3.3 1 0 2-.3 2.5-.5.4-.2.7-.3 1-.2.3.1.5.3.6.6l1.7 5c.2.4.3.8 0 1.1z"}));
}

Tumblr.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Tumblr;

Tumblr.default = Tumblr;
